import api from "./../api";
import UtilsUrl from "../../utils/UtilsUrl";
export function getWorkstations() {
  return api
    .get(UtilsUrl.productionURL() + "/workstations")
    .then((res) => res.data);
}

export function addWorkstation(data) {
  return api.post(UtilsUrl.productionURL() + "/workstations", data);
}

export function getWorkstationById({ queryKey }) {
  const [_resourceName, id] = queryKey;
  return api
    .get(UtilsUrl.productionURL() + `/workstations/getWorkstationsById/${id}`)
    .then((res) => res.data);
}
